import React, {useState} from "react";
import {useTable} from "react-table";

import {
    Button,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from "@material-ui/core";
import CancelRoundedIcon
    from "@material-ui/icons/CancelRounded";
import apiHelper from "../../../../util/ApiHelper";

export default function SideHomeSection(props) {
    const {
        defaultValues,
        Controller,
        control,
        getValues,
        setValue,
        lang,
        disabled,
    } = props;

    const [uploading, setUploading] = useState({});
    const [hoverToggle, setHoverToggle] = useState({});

    const columns = React.useMemo(
        () => [
            {
                Header: "Banner Image",
                accessor: "image",
            },
            {
                Header: "Banner Link/URL",
                accessor: "url",
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } =
        useTable(
            {
                columns,
                data: defaultValues || [],
            },
            (hook) => {
                hook.visibleColumns.push((columns) => [
                    {
                        id: "no",
                        Header: () => <div>No</div>,
                    },
                    ...columns,
                ]);
            }
        );

    const toggleHover = (index, bool) => {
        setHoverToggle({...hoverToggle, [index]: bool});
    };

    const uploadFile = async (file) => {
        try {
            const result = await apiHelper.cinefan.uploadFile(file);
            console.log(result.data.url);
            return result.data.url;
        } catch (err) {
            console.log(err);
        }
    };

    const handleFileUpload = async (index, e) => {
        setValue(`banners.${index}.localizations.${lang()}.image`, "loading");
        const file = e.target.files[0];
        if (file) {
            const url = await uploadFile(file);
            setValue(`banners.${index}.localizations.${lang()}.image`, url);
        }
        setUploading({...uploading, [index]: false});
    };

    const handleDeleteFile = (index) => {
        setValue(`banners.${index}.localizations.${lang()}.image`, "");
    };

    const handleSideHomeUrlChange = (index, e) => {
        setValue(`banners.${index}.localizations.${lang()}.url`, e.target.value);
    };

    return (
        <Paper variant="outlined">
            <Table {...getTableProps()}>
                <TableHead component="div">
                    {headerGroups.map((headerGroup) => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) =>
                                column.id === "no" ? (
                                    <TableCell
                                        style={{width: 100}}>No</TableCell>
                                ) : (
                                    <TableCell
                                        {...column.getHeaderProps()}
                                        style={column.id === "bannerImage" ? {width: 300} : {}}
                                    >
                                        {column.render("Header")}
                                    </TableCell>
                                )
                            )}
                        </TableRow>
                    ))}
                </TableHead>
                <TableBody {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                        prepareRow(row);
                        return (
                            <TableRow {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                    return (
                                        <TableCell {...cell.getCellProps()}>
                                            {cell.column.id === "no" ? (
                                                <p>{i + 1}</p>
                                            ) : cell.column.id === "image" ? (
                                                getValues(
                                                    `banners.${i}.localizations.${lang()}.image`
                                                ) ? (
                                                    uploading[i] ? (
                                                        <div>loading...</div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                width: "48px",
                                                                height: "40px",
                                                            }}
                                                            onMouseEnter={() => toggleHover(i, true)}
                                                            onMouseLeave={() => toggleHover(i, false)}
                                                        >
                                                            <img
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    cursor: "pointer"
                                                                }}
                                                                src={
                                                                    getValues(
                                                                        `banners.${i}.localizations.${lang()}.image`
                                                                    )
                                                                        ? getValues(
                                                                            `banners.${i}.localizations.${lang()}.image`
                                                                        )
                                                                        : defaultValues[i].localizations[lang()].image
                                                                }
                                                                alt=""
                                                                onClick={() => window.open(getValues(
                                                                    `banners.${i}.localizations.${lang()}.image`
                                                                )
                                                                    ? getValues(
                                                                        `banners.${i}.localizations.${lang()}.image`
                                                                    )
                                                                    : defaultValues[i].localizations[lang()].image, '_blank').focus()}
                                                            />
                                                            {hoverToggle[i] && !disabled && (
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        background: "#FFF",
                                                                        top: 0,
                                                                        right: 0,
                                                                        borderRadius: "100%",
                                                                        width: "12px",
                                                                        height: "12px",
                                                                    }}
                                                                >
                                                                    <CancelRoundedIcon
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: 0,
                                                                            right: 0,
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            transform: "scale(1.5)",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() => handleDeleteFile(i)}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                ) : (
                                                    <div>
                            <span
                                style={{paddingRight: "10px"}}>
                              No image selected
                            </span>
                                                        <input
                                                            style={{display: "none"}}
                                                            id={`upload-image-${i}`}
                                                            type="file"
                                                            onChange={(e) => {
                                                                setUploading({
                                                                    ...uploading,
                                                                    i: true
                                                                });
                                                                handleFileUpload(i, e);
                                                            }}
                                                        />
                                                        <Button
                                                            component="label"
                                                            htmlFor={`upload-image-${i}`}
                                                            variant="contained"
                                                            disableElevation
                                                            style={{
                                                                color: "#306F9D",
                                                                background: "#F1F1F1",
                                                                margin: "0px",
                                                                padding: "7px 15px",
                                                                border: "1px solid #306F9D",
                                                            }}
                                                        >
                                                            Add
                                                            Image
                                                        </Button>
                                                    </div>
                                                )
                                            ) : (
                                                <>
                                                    <Grid
                                                        style={lang() === "tc" ? {display: "none"} : {}}
                                                    >
                                                        <Controller
                                                            name={`banners.${i}.localizations.en.url`}
                                                            control={control}
                                                            defaultValue={defaultValues[i] ? defaultValues[i].localizations.en.url : ''}
                                                            render={({
                                                                         field,
                                                                         fieldState: {error}
                                                                     }) => (
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    fullWidth
                                                                    {...field}
                                                                    onChange={(e) =>
                                                                        handleSideHomeUrlChange(i, e)
                                                                    }
                                                                    error={!!error}
                                                                    helperText={error ? error.message : ""}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid
                                                        style={lang() === "en" ? {display: "none"} : {}}
                                                    >
                                                        <Controller
                                                            name={`banners.${i}.localizations.tc.url`}
                                                            control={control}
                                                            defaultValue={defaultValues[i] ? defaultValues[i].localizations.tc.url : ''}
                                                            render={({
                                                                         field,
                                                                         fieldState: {error}
                                                                     }) => (
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="dense"
                                                                    fullWidth
                                                                    {...field}
                                                                    onChange={(e) =>
                                                                        handleSideHomeUrlChange(i, e)
                                                                    }
                                                                    error={!!error}
                                                                    helperText={error ? error.message : ""}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </Paper>
    );
}
